import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const Container = styled.div`
  padding: 0 0 16px;
  min-height: 200px;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  font-size: 14px;
  color: ${theme.greyText};
`;

export const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 250px;
  padding: 0 24px;
  text-align: center;
`;

export const ErrorTitle = styled.p`
  font-size: 16px;
  font-weight: 700;
  color: ${theme.blackText};
  margin: 0 0 8px;
`;

export const ErrorSubtitle = styled.p`
  font-size: 14px;
  color: ${theme.greyText};
  margin: 0 0 24px;
`;

export const RetryButton = styled.button`
  padding: 10px 32px;
  border: 1px solid ${theme.blueText};
  border-radius: 8px;
  background: transparent;
  color: ${theme.blueText};
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: ${theme.blueText};
    color: ${theme.whiteText};
  }
`;

export const EmptyWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  font-size: 14px;
  color: ${theme.greyText};
`;

export const InvoiceRow = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 14px 16px;
  margin-bottom: 12px;
  background: ${theme.lightBlueBg};
  border: 1px solid ${theme.blueText};
  border-radius: 8px;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s;

  &:hover {
    background: ${theme.blueText}10;
  }
`;

export const InvoiceContent = styled.div`
  flex: 1;
  margin: 0 12px;
`;

export const InvoiceTitle = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: ${theme.blackText};
  margin: 0 0 2px;
`;

export const InvoiceDate = styled.p`
  font-size: 12px;
  color: ${theme.greyText};
  margin: 0;
`;

export const DownloadLabel = styled.span`
  font-size: 14px;
  color: ${theme.blueText};
  font-weight: 700;
`;
